import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, errText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft } from "lucide-react";
import { celebrate } from "@/lib/celebrate";

export default function StaffLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      celebrate();
      loginWithToken(data.access_token, { role: data.user.role, user: data.user });
      setTimeout(() => navigate(data.user.role === "super_admin" ? "/admin" : "/teacher"), 900);
    } catch (err) {
      setError(errText(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="text-sm text-slate-500 inline-flex items-center gap-1 mb-6" data-testid="back-home">
          <ArrowLeft className="h-4 w-4" /> Back
        </Link>
        <div className="soft-card p-8">
          <img src="/gdiot-logo-wide.png" alt="CT Skill Assessment" className="h-14 w-auto object-contain mb-4 mx-auto" data-testid="app-logo" />
          <h2 className="text-2xl font-head font-bold">Staff Sign In</h2>
          <p className="text-sm text-slate-500 mt-1">CT Skill Assessment · Super Admin & School Teacher accounts</p>
          <form onSubmit={submit} className="space-y-4 mt-7">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="staff-email-input" className="mt-1.5" placeholder="you@school.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="staff-password-input" className="mt-1.5" />
            </div>
            {error && <p className="text-sm text-rose-600" data-testid="staff-login-error">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="staff-login-submit">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>
          <Link to="/student-login" className="block text-center text-sm text-primary mt-6" data-testid="go-student-login">
            Are you a student? Continue here
          </Link>
        </div>
      </div>
    </div>
  );
}
